const stylesheet = () => ({
  radioButton: {
    width: '100%',
    height: `18px`,
    position: 'relative',
    display: 'flex',
    '& input[type="radio"]': {
      display: 'none',
    },
    '& input[type="radio"]:checked + label:before': {
      borderColor: '#B7C1E1',
      animation: 'ripple 0.3s linear forwards',
    },
    '& input[type="radio"]:checked + label:after': {
      transform: 'scale(1)',
    },
    '& span': {
      marginLeft: '29px',
    },
    '& label': {
      color: '#6373A4',
      fontSize: '12px',
      fontWeight: '500',
      cursor: 'pointer',
      letterSpacing: 0,
      lineHeight: '18px',

      '&:before': {
        position: 'absolute',
        content: "''",
        borderRadius: '50%',
        left: 0,
        top: 0,
        width: `18px`,
        height: `18px`,
        border: '1.6px solid #B7C1E1',
        boxSizing: 'border-box',
      },
      '&:after': {
        position: 'absolute',
        content: "''",
        borderRadius: '50%',
        transition: 'all 0.3s ease',
        top: '5px',
        left: '5px',
        width: `8px`,
        height: `8px`,
        transform: 'scale(0)',
        background: (props: any) =>
          props.selectedColor ? props.selectedColor : '#085fe5',
      },
    },
  },
});

export default stylesheet;
